import styled from "styled-components";

export const CategoryShareTableContainer = styled.div`
    .SWReactTableWrapperBox {
        border-radius: 0px;
    }
`;
